import Vue from "vue";
import VueHighlightJS from "vue-highlightjs";
import "highlight.js/styles/github.css"; // or other highlight.js theme

Vue.use(VueHighlightJS);
